export default "__VITE_ASSET__66a6691e__"